export const TOAST_DURATION = 3000;

export const COPY_DURATION = 3000;

export const SIDE_DURATION = 3000;

export const ICON_SIZE = "1.25rem";

export const STEPPER_DURATION = 500;

export const EXPLORER_URL = "https://sepolia.arbiscan.io/tx";

export const GB = 1_073_741_824;

export const TB = 1_099_511_627_776;

export const MOBILE_MAX_WIDTH = 999